module.exports = __webpack_public_path__ + "img/alteka_kards.93b92518.svg";